

export const getDomain = function () {
  if (!window.location.origin) { // Some browsers (mainly IE) does not have this property, so we need to build it manually...
    window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '')
  }
  return window.location.origin
}

/**
 * Get Node env
 */
export const getEnv = function () {
  return process.env.NODE_ENV
}

export const getVersion = function () {
  return process.env.VERSION_LABEL
}

export const isMock = () => process.env.NODE_ENV === 'development' && process.env.IS_MOCK === 'true'

export const isApiCompleted = () => process.env.NODE_ENV === 'development' && process.env.IS_API_COMPLETED === 'true'

export const devWarning = str => {
  if (process.env.NODE_ENV === 'development') {
    console.warn(`[DEV-WARN]: ${str}`)
  }
}

export const devError = str => {
  if (process.env.NODE_ENV === 'development') {
    console.error(`[DEV-ERROR]: ${str}`)
  }
}

// Clarity events are name-only (no payload), so event/identify data is stored
// as custom tags, which are session-scoped filters. Values must be strings.
export const setClarityTags = tags => {
  if (typeof window === 'undefined' || !window.clarity || !tags) {
    return
  }
  Object.keys(tags).forEach(key => {
    const value = tags[key]
    if (value !== null && value !== undefined && value !== '') {
      try {
        window.clarity('set', key, String(value))
      } catch (e) {
        console.error(e)
      }
    }
  })
}

export const clarityEvent = (eventName, eventData) => {
  if (process.env.NODE_ENV !== 'development') {
    if (window.clarity) {
      // Store the event payload as custom tags, then fire the name-only event.
      setClarityTags(eventData)
      try {
        window.clarity('event', eventName)
      } catch(e) {
        console.error(e)
      }
    }
  } else {
    console.log('clarityEvent')
    console.log('eventName:', eventName)
    console.log('eventData:', eventData)
  }
}
